// Centralized token storage and change events
const ACCESS_KEY = "accessToken";
const REFRESH_KEY = "refreshToken";

class TokenService {
  getAccessToken() {
    return localStorage.getItem(ACCESS_KEY);
  }

  getRefreshToken() {
    return localStorage.getItem(REFRESH_KEY);
  }

  storeTokens(tokens = {}) {
    if (tokens.accessToken) {
      localStorage.setItem(ACCESS_KEY, tokens.accessToken);
    }
    if (tokens.refreshToken) {
      localStorage.setItem(REFRESH_KEY, tokens.refreshToken);
    }
    // Dispatch event so other parts of app can react to token changes
    try {
      window.dispatchEvent(
        new CustomEvent("tokensChanged", {
          detail: {
            accessToken: this.getAccessToken(),
            refreshToken: this.getRefreshToken(),
          },
        })
      );
    } catch (e) {
      // ignore in non-browser environments
    }
  }

  clearTokens() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem("userData");
    try {
      window.dispatchEvent(
        new CustomEvent("tokensChanged", {
          detail: { accessToken: null, refreshToken: null },
        })
      );
    } catch (e) {}
  }

  subscribe(handler) {
    const fn = (e) => handler(e.detail);
    window.addEventListener("tokensChanged", fn);
    return () => window.removeEventListener("tokensChanged", fn);
  }
}

const tokenService = new TokenService();
export default tokenService;
